
import {Component, Vue} from 'vue-property-decorator';
import {readAdminForms, readAdminGroups, readInstitutions} from '@/store/admin/getters';
import {
  dispatchDeleteGroup, dispatchDeleteInstitution,
  dispatchGetFormsAdmin,
  dispatchGetGroups, dispatchGetInstitution,
  dispatchGetInstitutions,
} from '@/store/admin/actions';
import DynamicTable from '@/components/datatables/DynamicTable.vue';
import {SpecialFields} from '@/interfaces/constants';

@Component({
  components: {DynamicTable},
})
export default class GroupList extends Vue {

  private headers = [
    {text: this.$t('action'), value: 'action', align: 'center', filterable: false, sortable: false,
      router_name: 'main-admin-institution-edit', width: '100px', delete_function: this.deleteInstitution},
    {
      text: this.$t('name'),
      sortable: true,
      value: 'name',
      align: 'left',
    },
    {
      text: this.$t('administrative_region'),
      sortable: false,
      value: 'administrative_region',
      align: 'left',
    },
    {
      text: this.$t('cnes'),
      sortable: false,
      value: 'cnes',
      align: 'left',
    },
    {
      text: this.$t('address'),
      sortable: false,
      value: 'address',
      align: 'left',
    },
    {
      text: this.$t('responsible_name'),
      sortable: true,
      value: 'responsible_name',
      align: 'left',
    },
    {
      text: this.$t('phone'),
      sortable: false,
      value: 'phone',
      align: 'left',
    },
    {
      text: this.$t('institutional_doc'),
      sortable: false,
      value: 'institutional_doc',
      align: 'left',
      special_field: SpecialFields.PDFVisualizer,
    },
    {
      text: this.$t('responsible_doc'),
      sortable: false,
      value: 'responsible_doc',
      align: 'left',
      special_field: SpecialFields.PDFVisualizer,
    },
  ];

  get institutions() {
    return readInstitutions(this.$store);
  }

  public async mounted() {
    await dispatchGetInstitutions(this.$store);
  }

  public async deleteInstitution(id) {
    await dispatchDeleteInstitution(this.$store, id);
  }

}
